import { render, staticRenderFns } from "./InvoiceShowModal.vue?vue&type=template&id=4972fc12&scoped=true&"
import script from "./InvoiceShowModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceShowModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4972fc12",
  null
  
)

export default component.exports